import React, { useState } from 'react';
import { Button } from 'antd';
import './styles.scss';
import { MessageCircle } from 'lucide-react';

interface FloatingButtonProps {
  onClick: () => void;
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  buttonText?: string;
  icon?: React.ReactNode;
  pulse?: boolean;
  stacked?: boolean;
  ariaLabel?: string;
}

const FloatingButton: React.FC<FloatingButtonProps> = ({
  onClick,
  position = 'bottom-right',
  buttonText = 'Remarks',
  icon = <MessageCircle size={22} />,
  pulse = false,
  stacked = false,
  ariaLabel,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className={`floating-remarks-button ${position} ${isExpanded ? 'expanded' : 'collapsed'} ${pulse ? 'floating-remarks-button--pulse' : ''} ${stacked ? 'floating-remarks-button--stacked' : ''}`}
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
    >
      <Button
        type="primary"
        shape="round"
        size="large"
        icon={icon}
        onClick={onClick}
        aria-label={ariaLabel ?? buttonText}
      >
        <span className="button-text">{buttonText}</span>
      </Button>
    </div>
  );
};

export default FloatingButton;
